module.exports = __webpack_public_path__ + "static/media/OnTrial Logo Main.4f53336b.png";